import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/api.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotlistService {

  constructor(private api : ApiService) { }

  // get all ntification

  getAllnotification(pagination:any):Observable<any>{
if(localStorage.getItem('OGJWTTOKEN')!=null){let params = new HttpParams();

for (let data in pagination){
  if(pagination[data]!=''&& pagination[data]!=null && pagination[data]!=undefined){
    params = params.set(data,pagination)
  }
}
    return  this.api.get(`notification`)}
  }



  // read the notification
  readNotification(data:any):Observable<any>{
return this.api.post(`readNotification`,data)
  }
}
